import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
declare var jQuery: any;
declare var $: any;
import * as moment from "moment-timezone";

@Component({
  selector: 'app-t-twenty',
  templateUrl: './t-twenty.component.html',
  styleUrls: ['./t-twenty.component.scss']
})
export class TTwentyComponent implements OnInit {

	matchesList: any = "";
	livematchesList: any = {};
	timerconfig: any = {};
	bannerList: any = "";
	banneraddList: any = "";
	runnigList: any = "";
	joinList: any = "";
	partList: any = "";
	matchesrequest: any = {
		series_type_id : 1,
		series_type_name: 'T20',		
	};
	liverequest: any = {
		series_type_id : 1,
		series_type_name: 'T20',
		matche_status: 'Live'	
	};
	videoList: any = "";
	bannerrequest: any = {};
	videorequest: any = {
		video_catagory_id: 1
	};
	showTime: boolean = false;

  constructor(private allpagesService: AllPageService,) { }
  slidematchConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slideconcertsConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	slidePefectConfig = {
		//dots: true,
		infinite: true,
		arrows: true,
		slidesToShow: 3,
		autoplay: false,
		speed: 500,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
  ngOnInit() {
	  this.loadmatches();
	  this.loadlivematches();
	  this.loadBanner();
	  this.loadvideo();
	  this.loadAddBanner();

	  this.allpagesService.getRunningfoxList().then((data: any) => {
		this.runnigList = data;
		console.warn(this.runnigList);
	});

	this.allpagesService.getLookthepartList().then((data: any) => {
		this.partList = data;
		console.warn(this.partList);
	});

	this.allpagesService.getJointheList().then((data: any) => {
		this.joinList = data;
		console.warn(this.joinList);
	});
  }
  
  loadBanner() {
	this.bannerrequest = {
		title: 'T Twenty'
	};
	let request = Object.assign({}, this.bannerrequest);
	this.allpagesService.getBannerList(request).then((data: any) => {
		this.bannerList = data.data[0];
		//console.log(this.bannerList);
	});
	}

	loadAddBanner() {
		this.bannerrequest = {
			title: 'T Twenty Add'
		};
		let request = Object.assign({}, this.bannerrequest);
		this.allpagesService.getBannerList(request).then((data: any) => {
			this.banneraddList = data.data[0];
			//console.log(this.bannerList);
		});
		}

  loadmatches() {
	let request = Object.assign({}, this.matchesrequest);
	this.allpagesService.getMatcheslist(request).then((data: any) => {
		this.matchesList = data;
		console.warn(this.matchesList);
		console.warn(moment(data.data[0].date_time).format());
		this.predictCounter(moment(data.data[0].date_time).format());
	});
	
}
loadlivematches(){
	let request = Object.assign({}, this.liverequest);
	this.allpagesService.getMatcheslist(request).then((data: any) => {
		this.livematchesList = data;
		console.warn(this.livematchesList);
	});
}

predictCounter(timevar: any){
    var enddate = new Date(timevar);
	//var startdate = moment().format();
	var startdate = new Date(this.matchesList.data[0].uk_date_time);
	console.log(startdate);
    var seconds = (enddate.getTime() - startdate.getTime()) / 1000;
    var days_diff = (enddate.getTime() - startdate.getTime()) / (1000 * 3600 * 24);
    var newnum = days_diff.toFixed(0);
    this.timerconfig = { leftTime: seconds, format: '<ul><li>'+newnum+'</li><li>h</li><li>m</li><li>s</li></ul>' };
	this.showTime = true;
  }

loadvideo() {
		let request = Object.assign({}, this.videorequest);
		this.allpagesService.getVideoListing(request).then((data: any) => {
			this.videoList = data;
			//console.log(this.videoList);
			setTimeout(() => {
				
				jQuery('.popup-youtube').magnificPopup({
					type: 'iframe',
					mainClass: 'mfp-fade',
					removalDelay: 160,
					preloader: false,

					fixedContentPos: false
				});
			}, 1000);
		});
	}

}
